import axios from 'axios';
import { serviceUrl } from '../../App';

export const addAssignmentToCapacityElement=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`capacity/create`, obj, {
    headers,
  });
}
export const deleteCapacityElement=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`capacity/delete`, obj, {
    headers,
  });
}
export default class CapacityServices {
}
export const deleteCapacityIDlement=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`capacity/delete_id`, obj, {
    headers,
  });
}
export const addCapacityNote=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`capacity/add_note`, obj, {
    headers,
  });
}